// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rename-folder[data-v-9345b5aa],.rename-proof[data-v-9345b5aa]{position:absolute;top:8px;left:25px;width:280px;background-color:#fff;z-index:1}.clear-keyword[data-v-9345b5aa]{position:absolute;top:2px;right:35px;z-index:9}", ""]);
// Exports
module.exports = exports;
